import api from './api';

export interface AntiCheatEvent {
    event_type: string;
    name: string;
    description: string;
    severity: 'low' | 'medium' | 'high' | 'critical';
    timestamp: string;
}

export interface AntiCheatEventSummary {
    count: number;
    severity: 'low' | 'medium' | 'high' | 'critical';
    name: string;
    description: string;
}

interface DuplicateAssessment {
    inviter: string;
    status: string;
    date: string;
    days_ago: number;
    assignment_id: number;
}

export interface AntiCheatReport {
    assignment_id: number;
    candidate_name: string;
    test_name: string;
    total_events: number;
    flagged_events_count: number;
    risk_level: 'low' | 'medium' | 'high' | 'critical';
    event_summary: Record<string, AntiCheatEventSummary>;
    flagged_events: AntiCheatEvent[];
    has_violations: boolean;
    duplicate_assessments: DuplicateAssessment[];
    has_duplicates: boolean;
}

export const getAntiCheatReport = async (assignmentId: number): Promise<AntiCheatReport> => {
    const response = await api.get(`anti-cheat-report/${assignmentId}/`);
    return response.data;
};